"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCode = void 0;
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["NOT_AUTHENTICATED"] = "N\u00E3o autenticado";
    ErrorCode["FORBIDDEN"] = "Usu\u00E1rio permiss\u00E3o";
    ErrorCode["INVALID_TENANT"] = "Tenant inv\u00E1lido";
    ErrorCode["INVALID_REQUEST"] = "Requisi\u00E7\u00E3o inv\u00E1lida";
    ErrorCode["NOT_FOUND"] = "N\u00E3o encontrada";
    ErrorCode["ZABBIX_LOGIN_FAILED"] = "Falha ao autenticar no Zabbix";
    ErrorCode["NOT_METRO_USER"] = "API dispon\u00EDvel somente para usu\u00E1rios metro";
})(ErrorCode || (exports.ErrorCode = ErrorCode = {}));
